import { Text, useWindowSize } from '../../../../modules/Dashboard'
import { ReactComponent as BgVector } from '../../assets/analyze-type-bg.svg';
import { ReactComponent as LiteVector } from '../../assets/icons/lite-vector.svg';
import { ReactComponent as CompleteVector } from '../../assets/icons/complete-vector.svg';
import ModalLayout from "../../../../components/layouts/ModalLayout";
import { usePredictContext } from "../../context/PredictContextProvider";
import { useMemo } from "react";
import { MOBILE_SIZE } from '../../../../core/constants/common';
import MobileModal from '../../../../components/layouts/MobileModal';

const TYPES = [
    {
        method: 'lite',
        desc: "lite-desc",
        classNames: "!bg-gradient-to-br !from-[#59168B4D] !to-[#1C398E4D] !border !border-[#8200DB80]",
        Icon: LiteVector
    },
    {
        method: 'complete',
        desc: "complete-desc",
        classNames: "!bg-gradient-to-br !from-[#1C398E4D] !to-[#312C854D] !border !border-[#1447E680]",
        Icon: CompleteVector
    },
]

function ResponseTypeSelectContent({ usage, assistant, onSelect }) {
    return (
        <div className='grid grid-cols-1 gap-5 relative bg-[#101828] p-6 rounded-t-3xl md:rounded-xl'>
            <BgVector width="100%" height="100%" className="absolute top-0 left-0 z-[1]" />

            <div className="flex flex-col items-start gap-2">
                <Text tid={assistant?.value} className="text-2xl" />
                <Text tid="choose-analyzer-method-hint" className="text-sm opacity-80" />
            </div>

            {TYPES.map((type, idx) => {
                const { Icon } = type;
                return (
                    <div
                        key={idx}
                        className={`${type.classNames} rounded-2xl !p-6 relative cursor-pointer overflow-hidden flex flex-col gap-4 justify-start z-[2] backdrop-blur-sm`}
                        onClick={() => onSelect(type.method)}
                    >
                        <div className="flex items-center justify-start gap-2">
                            <Icon width={40} height={40} />
                            <div className="flex flex-col items-start gap-1">
                                <Text tid={type.method} />
                                <Text tid={type.desc} className="!opacity-80 text-sm" />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}


export default function ResponseTypeSelect({ open, onClose, onSelect }) {
    const { width } = useWindowSize()
    const { setResponseType, assistant: { assistant } } = usePredictContext();

    const handleSelect = (type) => {
        setResponseType(type);
        onSelect();
    };

    const usage = useMemo(() => {
        if (!assistant?.responseType) return {};
        return assistant.responseType.reduce((acc, item) => {
            acc[item.type] = item.cost;
            return acc;
        }, {});
    }, [assistant]);

    const Content = (
        <ResponseTypeSelectContent
            usage={usage}
            assistant={assistant}
            onSelect={handleSelect}
        />
    );

    return width >= MOBILE_SIZE ? (
        <ModalLayout open={open} onClose={onClose} width="550px" noBg>
            {Content}
        </ModalLayout>
    ) : (
        <MobileModal isOpen={open} onClose={onClose} noPadding noBg>
            {Content}
        </MobileModal>
    );
}
